import React from 'react';

const related = [
  ['HEART ou EDACS?', '/heart-versus-edacs/', 'Compare critérios e limites das vias para dor torácica.'],
  ['Guia de troponina', '/troponina/', 'Valores de referência, troponina alta ou alterada, I x T, ultrassensível e como interpretar na dor torácica.'],
  ['Escala de Wells', 'https://calculadorawells.com.br/wells-tep/', 'Ajuda a organizar a avaliação de embolia pulmonar como diagnóstico diferencial de dor torácica.'],
  ['Perfil lipídico', 'https://lipidico.com.br/', 'Oferece contexto para hipercolesterolemia, um dos fatores de risco considerados no HEART.'],
  ['Carga tabágica', 'https://cargatabagica.com.br/', 'Complementa a descrição da exposição ao tabaco e o histórico de tabagismo.'],
  ['Função renal', 'https://funcaorenal.com.br/', 'Acrescenta contexto sobre doença renal, contraste e interpretação de troponina.']
];

export default function Related() {
  return (
    <section className="related-section">
      <div className="section-heading"><span className="eyebrow">CONTINUE EXPLORANDO</span><h2>Calculadoras relacionadas</h2></div>
      <div className="related-grid">{related.map(([name, url, description]) => <a key={name} href={url} className="related-card"><strong>{name} <span aria-hidden="true">↗</span></strong><p>{description}</p></a>)}</div>
    </section>
  );
}
